import { Component, OnInit, Input } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { IUserInfo, AuthService } from '../../api/auth.service';
import { Router } from '@angular/router';
import { IAccountType } from '../../constants/account-types';

export const getSiteSectionColor = (accountType:IAccountType | null) => {
  switch(accountType){
    case IAccountType.TEST_ADMIN : return 'rgba(255, 214, 0, 0.37)';
    case IAccountType.TEST_TAKER : return 'rgba(99, 237, 35, 0.37)';
    case IAccountType.TEST_CTRL : return 'rgba(236, 64, 64, 0.37)';
    case IAccountType.CERT_BODY : return 'rgba(0, 0, 0, 0.37)';
    default: return 'rgba(64, 143, 236, 0.37)';
  }
}

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() breadcrumbPath:{caption:string, route:string}[];
  @Input() siteSection:boolean;
  @Input() hasPrint:boolean;
  @Input() icon:string;

  userInfo:IUserInfo;

  langs = [
    {code: 'en', caption: 'English'},
    {code: 'fr', caption: 'Français'},
  ]

  constructor(
    public langService:LangService,
    private router: Router,
    private auth: AuthService,
  ) { }

  ngOnInit() {
    this.auth
      .user()
      .subscribe(t => this.userInfo = t);
  }

  getStripColor(){
    if (this.userInfo){
      return getSiteSectionColor(this.userInfo.accountType);
    }
    return getSiteSectionColor(null);
  }

  getUserDisplayName(){
    return this.userInfo.firstName+' '+this.userInfo.lastName;
  }

  getLang(){
    return this.langService.getCurrentLanguage();
  }
  
  isLangActive(langCode:string){
    return (this.getLang() === langCode);
  }

  setLang(langCode:string) {
    this.langService.loadInLang(langCode);
  }

  gotoLogin(){
    this.router.navigate([
      this.langService.getCurrentLanguage(), 
      'test-admin', // TO DO : hard coded... this needs to be dynamic
      'login'
    ])
  }

  logout(){
    this.auth
      .logout()
      .then( r => this.gotoLogin() )
  }

  getSiteSection

}
